import { MFinanzaEdoCtaMovimiento } from "../../../../data/model/FinanzaEstadoCuenta/MFinanzaEdoCtaMovimiento";
import { MEscuela } from "../../../../data/model/MEscuela";
import _L from "../../../../util/Labels";
import { AlumnoEdoCtaUtil } from "../AlumnoEdoCtaUtil";

// type IEscuela = Entidad.IEscuela;

export namespace AlEdoCtaPagoFormUtil {

    export type IItemCargoPago = {
        Cargo: MFinanzaEdoCtaMovimiento;
        Pago: number;
    }
    export type IDataForm = {
        TipoPago: CTipoProcesoPago;
        IdsCargosParciales: number[];
        CargosToPay: IItemCargoPago[];
        IdMetodoPago: number;
        FechaPagoUTC: string;
    }

    export enum CTipoProcesoPago {
        PagoSaldoTotal = 1,
        PagoSaldoPeriodo = 2,
        PagoParcial = 3
    }

    export interface AlumnoEdoCtaPagoFormConfig {
        OnClose: () => void
        Escuela: MEscuela
        PreSeleccionados: MFinanzaEdoCtaMovimiento[]
        InfoGeneral: AlumnoEdoCtaUtil.ICurrentData
        OnAccept_SuccessPays: () => void
    }

    export function _GetFormTipoPagoName(tipoPago: CTipoProcesoPago): string {
        const namesMap: { [key: string]: string } = {
            [CTipoProcesoPago.PagoSaldoTotal]: _L("panelfinanzasedocuenta.tag_paytotal"),
            [CTipoProcesoPago.PagoSaldoPeriodo]: _L("panelfinanzasedocuenta.tag_payperiod"),
            [CTipoProcesoPago.PagoParcial]: _L("panelfinanzasedocuenta.tag_paypartial")
        }
        return namesMap[tipoPago];
    }
}